module.exports = __webpack_public_path__ + "images/button-pause-yellow.svg";